import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DnaBackground } from "@/components/DnaBackground";
import { Navigation } from "@/components/Navigation";
import UserDirectoryList from "@/components/UserDirectoryList";
import { getUserData } from "@/lib/api";

export default function UserDirectory() {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === "ar";
  const user = getUserData();

  return (
    <div className="min-h-screen overflow-x-hidden" dir={isRtl ? "rtl" : "ltr"}>
      <DnaBackground />
      <Navigation user={user} />

      <main className="pt-24 px-4 sm:px-6 pb-12">
        <div className="container mx-auto max-w-6xl min-w-0 space-y-6">
          <Button variant="ghost" className="gap-2 px-0" asChild>
            <Link to="/dashboard">
              <ArrowLeft className="h-4 w-4" />
              {t("userDirectory.backToDashboard")}
            </Link>
          </Button>

          <UserDirectoryList />
        </div>
      </main>
    </div>
  );
}

